<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div *ngIf="mostActiveViewersLabels.length > 0; else noDataTemplate" class="chart-dashboard">
  <div class="user-views-chart" [class.user-views-chart--compact]="hasFewerThanThreeUsers">
    <div class="header-row">
      <div class="chart-dashboard-title-items">
        <p class="chart-dashboard-title">
          {{ 'translations.analytics.charts.mostActiveViewers.title' | transloco }}
        </p>
        <mat-icon matTooltip="{{ 'translations.analytics.charts.mostActiveViewers.description' | transloco }}"> info_filled </mat-icon>
      </div>
      <button class="btn-sort" (click)="toggleSortOrder()" [attr.aria-label]="'translations.global.ariaLabels.toggleSorting' | transloco">
        <mat-icon>{{ sortOrder === 'desc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
      </button>
    </div>

    <div class="chart-wrapper">
      <div class="leaderboard">
        <div *ngFor="let user of mostActiveViewersLabels" class="leaderboard-item">
          <div
            class="user-info clickable"
            role="button"
            tabindex="0"
            [attr.aria-label]="'translations.global.ariaLabels.viewProfile' | transloco"
            (keyup.enter)="openInNewTab(user.userId)"
            (click)="openInNewTab(user.userId)"
          >
            <img [src]="user.imageUrl" class="avatar" alt="User avatar" />
            <div class="chart-label">{{ user.firstName }} {{ user.lastName }}</div>
          </div>
          <div class="chart-bar-wrapper" matTooltip="{{ user.firstName }} {{ user.lastName }}">
            <div class="chart-bar-fill" [style.width.%]="(user.views / maxViews) * 100"></div>
          </div>
          <div class="chart-bar-value">{{ user.views }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noDataTemplate>
  <div class="placeholder-container" *ngIf="showPlaceholder">
    <mat-icon class="placeholder-icon">visibility_off</mat-icon>
    <p class="placeholder-message">
      {{ 'translations.analytics.charts.mostActiveViewers.noViewsFound' | transloco }}
    </p>
    <p class="placeholder-description">
      {{ 'translations.analytics.charts.mostActiveViewers.noViewsFoundMessage' | transloco }}
    </p>
  </div>
</ng-template>
